import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { ProdutosProps } from 'pages/compra/configuracao-pedido/types';

const defaultRequestOptions: RequestOptionsType = {
    url: '/gestao/produto',
    sort: [{ property: 'cdProduto', direction: 'ASC' }],
    filter: [{ property: 'fgAtivo', operator: 'eq', value: true }],
    columns: 'idProduto,dsProduto,fgAtivo,cdProduto,fgFracionavel,dsMarca,dsGrupo,qtMinimaCompra',
};

type UseQueryProdutosModal = {
    open: boolean;
    selectedMarca: { idMarca: number } | null;
    valueFilter: string;
};

export function useQueryProdutosModal({ open, selectedMarca, valueFilter }: UseQueryProdutosModal) {
    const requestListagem = useRequestListagem();
    const { page, limit, sort } = useListagemContext();

    const filter = [...(defaultRequestOptions.filter || [])];

    if (selectedMarca?.idMarca) {
        filter.push({ property: 'idMarca', value: selectedMarca.idMarca, operator: 'eq' });
    }

    const requestOptions = {
        ...defaultRequestOptions,
        filter,
        sort: sort?.length ? sort : defaultRequestOptions.sort,
        query: valueFilter || undefined,
        page,
        limit,
    };

    return useQuery<RequestListagem<ProdutosProps[]>>({
        queryKey: ['config-pedido-produtos-modal', requestOptions],
        queryFn: () => requestListagem(requestOptions).then((res) => res.data),
        enabled: open,
    });
}
